import { ContextualMenu, getId, Icon, IDragOptions, Modal } from "@fluentui/react";
import { StyleUtils } from '../../../common/views/StyleUtils';
import { Utils } from '../../../common/views/Utils';
import { ShortCustomerModel } from '../../models/CustomerModel';
import CustomerView from './CustomerView';
import { useCustomerPickerVM } from '../../viewmodels/CustomerPickerVM';

type CustomerPickerProps = {
    onSelect: (customer?: ShortCustomerModel) => void;
}

export default function CustomerPicker({ onSelect }: CustomerPickerProps) {
    const _titleId: string = getId('title');
    const _subtitleId: string = getId('subText');
    const _dragOptions: IDragOptions = {
        moveMenuItemText: 'Move',
        closeMenuItemText: 'Close',
        menu: ContextualMenu,
        keepInBounds: true,
        dragHandleSelector: ".modal-drag-header"
    };

    const isMobile = window.innerWidth <= 500;
    const width2 = Utils.getColumnWidth(2);
    const width10 = Utils.getColumnWidth(10);

    const vm = useCustomerPickerVM();

    const onSelectedChange = (customer: ShortCustomerModel) => {
        vm.setValue(customer.id);
        vm.setText(customer.displayName);
        vm.setShowMenu(false);
        onSelect(customer);
    }

    const onClear = () => {
        vm.setValue(undefined);
        vm.setText("");
        onSelect(undefined);
    }

    const modalHeader = () => {
        return <div className="ms-Grid modal-drag-header">
            <div className="ms-Grid-row">
                <div className={width10}><b>Customers</b></div>
                <div className={width2 + " right"}>
                    <Icon
                        iconName="ChromeClose"
                        className="pointer"
                        onClick={() => vm.setShowMenu(false)}
                    />
                </div>
            </div>
        </div>;
    }

    const modalElement = () => {
        return <>
            <Modal
                titleAriaId={_titleId}
                subtitleAriaId={_subtitleId}
                isOpen={vm.showMenu}
                onDismiss={() => vm.setShowMenu(false)}
                styles={StyleUtils.getModalWidthStyles(450)}
                dragOptions={_dragOptions}
            >
                <div className="popup-header">
                    {modalHeader()}
                </div>
                <div
                    className={(isMobile ? "mobile-" : "") + "popup-body"}
                >
                    <CustomerView onSelect={onSelectedChange} />
                </div>
            </Modal>
        </>;
    }

    return <>
        <div className="pb-5 left">
            <label className="pr-5 bold">Customer</label>
            <Icon className="pointer" iconName="cancel" onClick={onClear} />
        </div>
        <div className="brand-dropdown" onClick={() => vm.setShowMenu(true)}>
            <div className="brand-dropdown-text">{vm.text}</div>
            <div className="brand-dropdown-icon"><Icon iconName="ChevronDown" /></div>
        </div>

        {modalElement()}
    </>;
}